import { useEffect, useMemo, useState } from "react";
import { getMediaUrls } from "../functions/apiFunctions/mediaUrls";

export function useMediaUrls(imageIds: (number | undefined | null)[]): Record<number, string> {
  const [urls, setUrls] = useState<Record<number, string>>({});

  const ids = useMemo(() => [...new Set(imageIds.filter((imageId): imageId is number => typeof imageId === "number" && imageId > 0))].sort((a, b) => a - b), [imageIds]);
  const idsKey = ids.join(",");

  useEffect(() => {
    if (ids.length === 0) return;
    let isCurrent = true;
    getMediaUrls(ids).then((resolvedUrls) => {
      if (isCurrent) setUrls(resolvedUrls);
    });
    return () => {
      isCurrent = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idsKey]);

  return urls;
}
